import styled from 'styled-components';

export const Btn = styled.input`
  display: none;
`;
